module.exports = __webpack_public_path__ + "img/logo.41c3fb7.svg";